export default __webpack_public_path__ + "static/media/SumantKrSinha_Crest.8e66b07e.jpeg";